import store from '@Store';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

import Auth from '@Services/Auth';
import History from '@Services/History';
import Catalyst from '@Services/Catalyst';
import history from '@AppRoutes/history';

import { isStateSameOrParent } from '@Utils/router-state';
import { generatePath } from 'react-router';
import { paths } from '@AppRoutes/constants';

import AppStorage from '@Services/AppStorage';
import { openRegisterModal } from '@Pages/Login/Register/RegisterActions';
import { openLoginModal } from '@Pages/Login/LoginActions';
import {
  setActiveResultsType,
  setIsAEMockType,
  setUserDropdownOpenType,
  logoutTitle,
  logoutMessage,
  isLoggedInUserDropdownOpenKey,
  isPersonalizationUserDropdownOpenKey,
} from './HeaderComponentConstants';

export function setActiveResults(activeResults) {
  return {
    type: setActiveResultsType,
    activeResults,
  };
}

export function dispatchSetActiveResults(...args) {
  store.dispatch(setActiveResults(...args));
}

export function setIsAEMock(isAEMock) {
  return {
    type: setIsAEMockType,
    isAEMock,
  };
}

export function setUserDropdownOpen(isUserDropdownOpen, key) {
  return {
    type: setUserDropdownOpenType,
    key,
    isUserDropdownOpen,
  };
}

export function setLoggedInUserDropdownOpen(isUserDropdownOpen) {
  return (dispatch) => {
    dispatch(setUserDropdownOpen(isUserDropdownOpen, isLoggedInUserDropdownOpenKey));
  };
}

export function setPersonalizationUserDropdownOpen(isUserDropdownOpen) {
  return (dispatch) => {
    dispatch(setUserDropdownOpen(isUserDropdownOpen, isPersonalizationUserDropdownOpenKey));
  };
}

// Call to external actions
export function goToRouterState(toState, params) {
  return () => {
    const currentPathName = history.location.pathname;
    const nextPathName = generatePath(toState);
    if (isStateSameOrParent(currentPathName, nextPathName)) {
      return;
    }

    history.push({
      pathname: nextPathName,
      state: { ...params },
    });
  };
}

export function goToResults() {
  return () => History.goToResultPage();
}

export function goToLogin() {
  return (dispatch) => {
    const userData = AppStorage.instance.get('userInstitutionInfo');
    const isRememberInstitution = userData && userData.rememberChoice;

    Catalyst.trackConversionDriverClick('header:sign-in');

    if (isRememberInstitution) {
      history.push({
        pathname: paths.LOGIN_INSTITUTION,
      });
    } else {
      dispatch(openLoginModal());
    }
  };
}

export function openLogoutDialog() {
  return () => Auth.logoutOnExpiredSession(logoutTitle, logoutMessage, true);
}

export function openRegisterDialog() {
  return (dispatch) => {
    Catalyst.trackConversionDriverClick('header:register');
    // was migrated to React in scope of https://jira.elsevier.com/browse/RX-5581. see RegisterModal.jsx
    dispatch(openRegisterModal());
  };
}

export function getRouterHref(path) {
  return () => {
    const generatedPath = generatePath(path);
    return history.createHref({ pathname: generatedPath });
  };
}

export function triggerAdobeTargetView(viewName, options) {
  return () => {
    const triggerView = getValueByNs(window, 'adobe.target.triggerView');

    if (triggerView) {
      triggerView(viewName, options);
    }
  };
}
